<organization-top-navbar></organization-top-navbar>

<div class="block; relative isolate px-6 lg:px-8 mt-16">
  <div class="mx-auto max-w-5xl px-4 py-6">
    <div class="text-[#1B3777] text-center text-3xl lg:text-4xl DisplayHeading self-stretch font-bold">{{
    'DRIVE_IN_BOOKING.DRIVE-IN' | transloco }}</div>
  </div>
</div>

<div class="container margin-auto">
  @if (showRegInputField) {
    <form [formGroup]="driveInBookingForm">
      @if(!parkingFound && !wrongParking && !ParkingToBeCreated){
        <div class="text-xl md:text-xl md:block w-97 text-center font-small leading-none mt-3"
          class="margin-bottom-14">
          {{
        'DRIVE_IN_BOOKING.VERIFY_REG_NUMBER' | transloco }}</div>
        <!-- Registration Number Edit Info -->
        <div class="flex-center-gap-4">
          <small class="small-text-center">{{ 'DRIVE_IN_BOOKING.EDIT_REG_NUMBER' |
          transloco }}</small>
        </div>
      }
      <div class="flex-center-relative">
        <div class="width-400">
          @if (!isEditingRegNo) {
            <div (click)="enableRegNoEdit()"
              class="reg-number-display"
              [style.cursor]="hasApiResponse() ? 'default' : 'pointer'">
              @if (getFormattedRegNo()) {
                <span>{{ getFormattedRegNo() }}</span>
              } @else {
                <span class="text-muted">{{ 'DRIVE_IN_BOOKING.INFO_MSG' | transloco }}</span>
              }
            </div>
          }
          @if (isEditingRegNo) {
            <mat-form-field appearance="outline" class="form-field-full-width">
              <mat-label>{{ 'DRIVE_IN_BOOKING.REG_NUMBER' | transloco }}</mat-label>
              <input (input)="regToUpper();"
                (blur)="updateUrlWithRegNumber($event.target.value); disableRegNoEdit();" matInput
                [formControl]='driveInBookingForm.controls["registrationNumber"]' #regInput [minlength]="4"
                [maxlength]="9"
                class="reg-input-large">
            </mat-form-field>
          }
        </div>
      </div>
      @if(!parkingFound && !wrongParking && !ParkingToBeCreated){
        <div class="flex-center-relative">
          <div class="width-400">
            <div class="flex-space-between-mt-18">
              <button mat-raised-button color="warn" type="button" class="width-45"
                (click)="resetdriveInBookingForm()">{{
              'DRIVE_IN_BOOKING.CHANGE' | transloco | uppercase}}</button>
              <button mat-raised-button type="button" class="btn-success-45"
                [style.cursor]="(isLoading || driveInBookingForm.get('registrationNumber')?.value?.length < 2) ? 'not-allowed !important' : 'pointer'"
                [style.opacity]="(isLoading || driveInBookingForm.get('registrationNumber')?.value?.length < 2) ? '0.7 !important' : '1'"
                (click)="submitForm()"
                [disabled]="isLoading || driveInBookingForm.get('registrationNumber')?.value?.length < 2">
                @if (isLoading) {
                  <mat-icon>
                    <mat-spinner color="accent" diameter="20">
                    </mat-spinner>
                  </mat-icon>
                  }{{ 'DRIVE_IN_BOOKING.SUBMIT' | transloco }}
                </button>
              </div>
            </div>
          </div>
        }
      </form>
    }

    <!-- Success Message -->
    @if (parkingFound) {
      <div class="message-container success-message margin-top-35">
        <div class="message-content text-center">
          <h3 class="heading-2rem">{{ 'DRIVE_IN_BOOKING.WELCOME_TO_SKAVSTA' | transloco }}
          </h3>
          <p class="message-text-large">
            {{ 'DRIVE_IN_BOOKING.PARKING_FOUND_MSG_1' | transloco }} - {{
            $safeNavigationMigration(driveInBookingForm.get('registrationNumber')?.value) | uppercase }}.<br>
            {{ 'DRIVE_IN_BOOKING.THANK_YOU_FOR_PARKING' | transloco }}
          </p>
        </div>
      </div>
    }

    <!-- Parking To Be Created Message -->
    <!-- <div *ngIf="ParkingToBeCreated" class="message-container info-message margin-top-35">
    <div class="message-content text-center">
      <h3 class="heading-2rem">{{ 'DRIVE_IN_BOOKING.WELCOME_TO_SKAVSTA' | transloco }}
      </h3>
      <p class="message-text-large">
        <strong>{{ 'DRIVE_IN_BOOKING.CREATE_PARKING_MSG_1' | transloco }}:</strong> {{
        'DRIVE_IN_BOOKING.CREATE_PARKING_MSG_2' | transloco }}<br><br>
        {{ 'DRIVE_IN_BOOKING.CREATE_PARKING_MSG_3' | transloco }}
      </p>
      <div class="action-buttons flex justify-center display-inline-block">
        <button mat-raised-button color="primary"
          class="text-sm sm:text-base md:text-lg px-3 sm:px-6 py-2 sm:py-3 md:py-4 lg:py-5 whitespace-nowrap"
          (click)="goToBookingForm()">{{ 'DRIVE_IN_BOOKING.COMPLETE_BOOKING' | transloco |
        uppercase}}</button>
      </div>
    </div>
  </div> -->

  <!-- Wrong Parking Message -->
  @if (wrongParking) {
    <div class="message-container error-message margin-top-35">
      <div class="message-content text-center">
        <h3 class="heading-2rem">{{ 'DRIVE_IN_BOOKING.WELCOME_TO_SKAVSTA' | transloco }}
        </h3>
        <p class="message-text-large">
          {{ 'DRIVE_IN_BOOKING.WRONG_PARKING_MSG_1' | transloco }} - {{
          correctParkingSite | uppercase }}.<br>
          {{ 'DRIVE_IN_BOOKING.WRONG_PARKING_MSG_2' | transloco }}
        </p>
      </div>
    </div>
  }

  @if (showbookingDetailsForm) {
    <section class="img-container img-fluid pt-4">
      <div class="pt-4 pb-2">
        <div class=" text-[#1B3777] text-xl md:text-2xl font-bold md:block w-97 leading-normal tracking-wide">{{
        'DRIVE_IN_BOOKING.ADD_BOOKING_DETAILS' | transloco }}</div>
      </div>
    </section>
  }

</div>